  import React from 'react';
import { __ } from '../../Lang.js';
const GuestDevices = () => {
  return (
    <section className="section devices">
      <div className="devices__text">
        <h2>{__('J-R and John at your fingertips')}</h2>
        <p>{__('Watch or listen on your phone, tablet, or computer')}</p>
      </div>
      <div className="devices__image">
        <img
          src="https://now.cdn.msia.org/3259/TWI/twi_devices.png"
          alt="Device mockups"
        />
      </div>
    </section>
  );
};

export default GuestDevices;